// extracted by mini-css-extract-plugin
module.exports = {"weeks":"VisibleWeeks_weeks__1Txch","week":"VisibleWeeks_week__31fhR","days":"VisibleWeeks_days__UUZMM","day":"VisibleWeeks_day__1Ju1G","active":"VisibleWeeks_active__u8Ep9"};